import React from 'react';
import SpecialOffersAboveTheFold from '@hpstellar/pdp/SpecialOffersAboveTheFold';

import withPageComponents from '../../../page/components/with-page-components';


const abfOffers = ({ product, device, showFor = [], className }) => {
    if (product && product.offers && product.offers.length > 0 && showFor.includes(device)) {
        const { offers } = product;
        const offerCount = offers.length;
        const [firstOffer] = offers;
        let offetText = `${firstOffer.value}${offerCount > 1 ? ` AND ${offerCount - 1} MORE PROMOTION${offerCount > 2 ? 'S' : ''}` : ''}`
        return <SpecialOffersAboveTheFold
            className={className}
            title={offetText}
            anchorLinkText="Learn more" />;
    }
    return null
}

export default withPageComponents(abfOffers, { components: ['product'], device: true })
